/**
 * The RoomSelectorListTemplateData contains all data needed to hydrate a RoomSelector view
 */
export const RoomSelectorListTemplate = () => {
  return `
  <div class="w-room-selector__item-wrapper w-room-selector__item w-room-selector__items-list">
  </div>
  `
}
